import React, { useEffect, useRef, useState } from "react";
import Modal from "../Modal";
import Form, { Cancel, Checkbox, InputNumber, Label, Radio, Submit, Title, Validation } from "../Form";
import { useDispatch } from "react-redux";
import { get, post } from "../../actions/general";
import { PriceContainer } from "./styles";
import { useIntl } from "react-intl";
import { useUser } from "../../store/user/selectors";

const Question = () => {
    const { locale } = useIntl();
    const user = useUser();
    const dispatch = useDispatch();
    const [show, setShow] = useState(false);
    const [noSubscription, setNoSubscription] = useState(false);
    const [price, setPrice] = useState("");
    const [bySchool, setBySchool] = useState<null | string>(null);

    const [numberValidation, setNumberValidation] = useState<string | null>(null);
    const [bySchoolValidation, setBySchoolValidation] = useState<string | null>(null);
    const activatedTime = useRef(0);

    const timer = useRef<ReturnType<typeof setTimeout>>(null);
    const checkToShow = () => {
        dispatch(get("price-question", (res) => {
            if (res.data.canShow) {
                activatedTime.current = Date.now();
                setShow(true);
            }
        }));
    };

    useEffect(() => {
        if (locale !== "lt" || !user._id) return;
        timer.current = setTimeout(checkToShow, 5000);
        return () => {
            clearTimeout(timer.current);
        }
    }, [user._id])
    useEffect(() => {
        setNumberValidation(null);
        setBySchoolValidation(null);
    }, [price, bySchool])
    const onClose = () => {
        if (Date.now() - activatedTime.current < 2000) return;
        dispatch(post("skip-price-question", {}, () => {
            setShow(false)
        }))
    }
    const onSubmit = () => {
        if (!price || Number.isNaN(Number(price))) {
            return setNumberValidation("Kötelező kitölteni!")
        }

        if (!bySchool && price !== "0") {
            return setBySchoolValidation("Kötelező kitölteni!");
        }
        dispatch(post("price-question", { noSubscription: price === "0", price: Number(price), bySchool: bySchool === "yes" }, (res) => {
            setShow(false);
        }));
    }
    if (!show) {
        return null;
    }
    return (
        <Modal close={onClose} >
            <Title>Klausimas</Title>
            <Form>

                <Label>
                    <span style={{ fontSize: 18 }}>
                        Jei reikėtų prenumeruoti „Musicators“, kokią mėnesinę kainą laikytum priimtina?
                    </span>
                </Label>
                {numberValidation && (
                    <Validation plainText={numberValidation} />
                )}
                <Radio
                    value={price}
                    onChange={e => setPrice(e.target.value)}
                    options={[
                        { label: "€3.99 / mėn", value: "3.99" },
                        { label: "€5.99 / mėn", value: "5.99" },
                        { label: "€8.99 / mėn", value: "8.99" },
                        { label: "Neprenumeruočiau", value: "0" },
                    ]}
                    />
                <Label>
                    <span style={{ fontSize: 18 }}>
                        Ar tavo mokykla ar institucija galėtų apmokėti prenumeratą?
                    </span>
                </Label>
                {bySchoolValidation && (
                    <Validation plainText={bySchoolValidation} />
                )}
                <Radio value={bySchool} onChange={e => setBySchool(e.target.value)} options={[{ label: "Taip", value: "yes" }, { label: "Ne, mokėčiau pats / pati", value: "no" }]} />
                <Label>
                    Tai nėra mokėjimas, tik trumpas atsiliepimas.
                </Label>
                <Submit onClick={onSubmit}>Pateikti</Submit>
                <Cancel onClick={onClose}>Uždaryti</Cancel>
            </Form>

        </Modal>
    );
};

export default Question;
